// eslint-disable-next-line import/prefer-default-export
export const countryList = [
  { name: 'Afghanistan', code: 'AF' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'Andorra', code: 'AD' },
  { name: 'Angola', code: 'AO' },
  { name: 'Antigua and Barbuda', code: 'AG' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Australia', code: 'AU' },
  { name: 'Austria', code: 'AT' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Belarus', code: 'BY' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Belize', code: 'BZ' },
  { name: 'Benin', code: 'BJ' },
  { name: 'Bhutan', code: 'BT' },
  { name: 'Bolivia', code: 'BO' },
  { name: 'Bosnia and Herzegovina', code: 'BA' },
  { name: 'Botswana', code: 'BW' },
  { name: 'Brazil', code: 'BR' },
  { name: 'Brunei', code: 'BN' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Cabo Verde', code: 'CV' },
  { name: 'Cambodia', code: 'KH' },
  { name: 'Cameroon', code: 'CM' },
  { name: 'Canada', code: 'CA' },
  { name: 'Central African Republic', code: 'CF' },
  { name: 'Chad', code: 'TD' },
  { name: 'Chile', code: 'CL' },
  { name: 'China', code: 'CN' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Comoros', code: 'KM' },
  { name: 'Congo (Congo-Brazzaville)', code: 'CG' },
  { name: 'Costa Rica', code: 'CR' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Cuba', code: 'CU' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Czechia', code: 'CZ' },
  { name: 'Democratic Republic of the Congo', code: 'CD' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Djibouti', code: 'DJ' },
  { name: 'Dominica', code: 'DM' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'East Timor (Timor-Leste)', code: 'TL' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Egypt', code: 'EG' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Equatorial Guinea', code: 'GQ' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Eswatini', code: 'SZ' },
  { name: 'Ethiopia', code: 'ET' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'Gabon', code: 'GA' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Germany', code: 'DE' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Greece', code: 'GR' },
  { name: 'Grenada', code: 'GD' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Guinea-Bissau', code: 'GW' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Haiti', code: 'HT' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Iceland', code: 'IS' },
  { name: 'India', code: 'IN' },
  { name: 'Indonesia', code: 'ID' },
  { name: 'Iran', code: 'IR' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Israel', code: 'IL' },
  { name: 'Italy', code: 'IT' },
  { name: 'Ivory Coast', code: 'CI' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Japan', code: 'JP' },
  { name: 'Jordan', code: 'JO' },
  { name: 'Kazakhstan', code: 'KZ' },
  { name: 'Kenya', code: 'KE' },
  { name: 'Kiribati', code: 'KI' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: 'Laos', code: 'LA' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Lesotho', code: 'LS' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Libya', code: 'LY' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Mali', code: 'ML' },
  { name: 'Malta', code: 'MT' },
  { name: 'Marshall Islands', code: 'MH' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Micronesia', code: 'FM' },
  { name: 'Moldova', code: 'MD' },
  { name: 'Monaco', code: 'MC' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Montenegro', code: 'ME' },
  { name: 'Morocco', code: 'MA' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Myanmar (formerly Burma)', code: 'MM' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Nauru', code: 'NR' },
  { name: 'Nepal', code: 'NP' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Niger', code: 'NE' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'North Korea', code: 'KP' },
  { name: 'North Macedonia', code: 'MK' },
  { name: 'Norway', code: 'NO' },
  { name: 'Oman', code: 'OM' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Palau', code: 'PW' },
  { name: 'Panama', code: 'PA' },
  { name: 'Papua New Guinea', code: 'PG' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Peru', code: 'PE' },
  { name: 'Philippines', code: 'PH' },
  { name: 'Poland', code: 'PL' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Qatar', code: 'QA' },
  { name: 'Romania', code: 'RO' },
  { name: 'Russia', code: 'RU' },
  { name: 'Rwanda', code: 'RW' },
  { name: 'Saint Kitts and Nevis', code: 'KN' },
  { name: 'Saint Lucia', code: 'LC' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC' },
  { name: 'Samoa', code: 'WS' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Sao Tome and Principe', code: 'ST' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Serbia', code: 'RS' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'Sierra Leone', code: 'SL' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Solomon Islands', code: 'SB' },
  { name: 'Somalia', code: 'SO' },
  { name: 'South Africa', code: 'ZA' },
  { name: 'South Korea', code: 'KR' },
  { name: 'South Sudan', code: 'SS' },
  { name: 'Spain', code: 'ES' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Sudan', code: 'SD' },
  { name: 'Suriname', code: 'SR' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'Syria', code: 'SY' },
  { name: 'Taiwan', code: 'TW' },
  { name: 'Tajikistan', code: 'TJ' },
  { name: 'Tanzania', code: 'TZ' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Togo', code: 'TG' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Trinidad and Tobago', code: 'TT' },
  { name: 'Tunisia', code: 'TN' },
  { name: 'Turkey', code: 'TR' },
  { name: 'Turkmenistan', code: 'TM' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Uganda', code: 'UG' },
  { name: 'Ukraine', code: 'UA' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'United Kingdom', code: 'GB' },
  { name: 'United States of America', code: 'US' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'Uzbekistan', code: 'UZ' },
  { name: 'Vanuatu', code: 'VU' },
  { name: 'Vatican City', code: 'VA' },
  { name: 'Venezuela', code: 'VE' },
  { name: 'Vietnam', code: 'VN' },
  { name: 'Yemen', code: 'YE' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Zimbabwe', code: 'ZW' },
]

export const pepTypeList = [
  { name: 'Contactpersoon', code: 'Contactpersoon' },
  { name: 'Directeur', code: 'Directeur' },
  { name: 'Begunstigde', code: 'Begunstigde' },
  { name: 'Aandeelhouder', code: 'Aandeelhouder' },
]

export const usPersonTypeList = [
  { name: 'US Citizen', code: 'US Citizen' },
  { name: 'US Resident', code: 'US Resident' },
  { name: 'Green Card Holder', code: 'Green Card Holder' },
  { name: 'US Tax Resident', code: 'US Tax Resident' },
]

export const sectorList = [
  { name: 'Aardolieverwerking en raffinage', code: 'Aardolieverwerking en raffinage' },
  { name: 'Accountancy, belast. Adv, administratie', code: 'Accountancy, belast. Adv, administratie' },
  { name: 'Activiteiten van holdingmaatschappijen', code: 'Activiteiten van holdingmaatschappijen' },
  { name: 'Actuariële diensten', code: 'Actuariële diensten' },
  { name: 'Algemene banken', code: 'Algemene banken' },
  { name: 'Assurantietussenpersonen', code: 'Assurantietussenpersonen' },
  { name: 'Bedrijfsorganisaties', code: 'Bedrijfsorganisaties' },
  { name: 'Bejaardentehuis', code: 'Bejaardentehuis' },
  { name: 'Bekleding metaal, opp Behandeling', code: 'Bekleding metaal, opp Behandeling' },
  { name: 'Beroepsorganisaties', code: 'Beroepsorganisaties' },
  { name: 'Beveiliging via beveiligingssystemen', code: 'Beveiliging via beveiligingssystemen' },
  { name: 'Bioscopen', code: 'Bioscopen' },
  { name: 'Bloemenkwekerij', code: 'Bloemenkwekerij' },
  { name: 'Bouw van schepen en drijvend materiaal', code: 'Bouw van schepen en drijvend materiaal' },
  { name: 'Callcenters', code: 'Callcenters' },
  { name: 'Cargo afhandeling', code: 'Cargo afhandeling' },
  { name: 'Centrale Bank', code: 'Centrale Bank' },
  { name: 'Citrusteelt', code: 'Citrusteelt' },
  { name: 'Cliënten die internetdiensten aanbieden en of faciliteren', code: 'Cliënten die internetdiensten aanbieden en of faciliteren' },
  { name: 'Combinatie van akkerbouw en dierenkwekerij', code: 'Combinatie van akkerbouw en dierenkwekerij' },
  { name: 'Cultureel onderwijs', code: 'Cultureel onderwijs' },
  { name: 'Culturele uitleencentra, openbaar archieven', code: 'Culturele uitleencentra, openbaar archieven' },
  { name: 'Detective bureaus', code: 'Detective bureaus' },
  { name: 'Dienstverlening voor de luchtvaart', code: 'Dienstverlening voor de luchtvaart' },
  { name: 'Dienstverlening voor het onderwijs', code: 'Dienstverlening voor het onderwijs' },
  { name: 'Dienstverlening voor vervoer over water', code: 'Dienstverlening voor vervoer over water' },
  { name: 'Dienstverlening winning aardolie, aardgas', code: 'Dienstverlening winning aardolie, aardgas' },
  { name: 'Dienstverlening winning overige delfstoffen', code: 'Dienstverlening winning overige delfstoffen' },
  { name: 'Dienstverlening voor vervoer over land', code: 'Dienstverlening voor vervoer over land' },
  { name: 'Draad gebonden telecommunicatie', code: 'Draad gebonden telecommunicatie' },
  { name: 'Dieren- en plantentuin; natuurbehoud', code: 'Dieren- en plantentuin; natuurbehoud' },
  { name: 'Distributie films, televisieproducties', code: 'Distributie films, televisieproducties' },
  { name: 'Draadloze telecommunicatie', code: 'Draadloze telecommunicatie' },
  { name: 'Drukkerijen', code: 'Drukkerijen' },
  { name: 'Exploitatie van bossen', code: 'Exploitatie van bossen' },
  { name: 'Exporteurs van rondhout', code: 'Exporteurs van rondhout' },
  { name: 'Facilitaire activiteiten film, televisie', code: 'Facilitaire activiteiten film, televisie' },
  { name: 'Farmaceutische, medicinale grondstoffen', code: 'Farmaceutische, medicinale grondstoffen' },
  { name: 'Fotografie en ontwikkelen foto\'s, film', code: 'Fotografie en ontwikkelen foto\'s, film' },
  { name: 'Fruitteelt m.u.v. citrus', code: 'Fruitteelt m.u.v. citrus' },
  { name: 'Gegevensverwerking, web hosting', code: 'Gegevensverwerking, web hosting' },
  { name: 'Geldwisselkantoor', code: 'Geldwisselkantoor' },
  { name: 'Grafische afwerking & ov act. Drukkerij', code: 'Grafische afwerking & ov act. Drukkerij' },
  { name: 'Groenteteelt, wortel, knolgewassen', code: 'Groenteteelt, wortel, knolgewassen' },
  { name: 'Haar- en schoonheidsverzorging', code: 'Haar- en schoonheidsverzorging' },
  { name: 'Handel in eigen onroerend goed', code: 'Handel in eigen onroerend goed' },
  { name: 'Handelaren in goud, andere edelmetalen en edelstenen', code: 'Handelaren in goud, andere edelmetalen en edelstenen' },
  { name: 'Hoger onderwijs', code: 'Hoger onderwijs' },
  { name: 'Horeca cafes', code: 'Horeca cafes' },
  { name: 'Horeca eventcatering', code: 'Horeca eventcatering' },
  { name: 'Horeca hotels', code: 'Horeca hotels' },
  { name: 'Horeca kantines en contractering', code: 'Horeca kantines en contractering' },
  { name: 'Horeca Restaurants', code: 'Horeca Restaurants' },
  { name: 'Houtzagerijen', code: 'Houtzagerijen' },
  { name: 'ICT consultancy', code: 'ICT consultancy' },
  { name: 'Informatieverstrekking toerisme', code: 'Informatieverstrekking toerisme' },
  { name: 'Ingenieurs, technisch ontwerp, advies', code: 'Ingenieurs, technisch ontwerp, advies' },
  { name: 'Interieurreiniging van gebouwen', code: 'Interieurreiniging van gebouwen' },
  { name: 'Interieurverzorging, babysitting', code: 'Interieurverzorging, babysitting' },
  { name: 'Keuring en controle', code: 'Keuring en controle' },
  { name: 'Kinderdagverblijven, creches', code: 'Kinderdagverblijven, creches' },
  { name: 'Kippenkwekerij', code: 'Kippenkwekerij' },
  { name: 'Koerier diensten', code: 'Koerier diensten' },
  { name: 'Kredietinformatie en incasso bureaus', code: 'Kredietinformatie en incasso bureaus' },
  { name: 'Kunst algemeen', code: 'Kunst algemeen' },
  { name: 'Kweken van zeevis en schaaldieren', code: 'Kweken van zeevis en schaaldieren' },
  { name: 'Landschapsverzorging', code: 'Landschapsverzorging' },
  { name: 'Lease copyright, intellectuele eigendom', code: 'Lease copyright, intellectuele eigendom' },
  { name: 'Liefdadigheidsinstellingen', code: 'Liefdadigheidsinstellingen' },
  { name: 'Loterijen en kansspelen', code: 'Loterijen en kansspelen' },
  { name: 'Maken en uitgeven van geluidsopnamen', code: 'Maken en uitgeven van geluidsopnamen' },
  { name: 'Management consultancy activiteiten', code: 'Management consultancy activiteiten' },
  { name: 'Markt- en opinieonderzoekbureaus', code: 'Markt- en opinieonderzoekbureaus' },
  { name: 'Markthandel overige artikelen', code: 'Markthandel overige artikelen' },
  { name: 'Markthandel voedings- en genotmiddelen', code: 'Markthandel voedings- en genotmiddelen' },
  { name: 'Markthandel, textiel, kleding, schoenen', code: 'Markthandel, textiel, kleding, schoenen' },
  { name: 'Medische en tandheelkundige praktijken', code: 'Medische en tandheelkundige praktijken' },
  { name: 'Musea, kunstgalerieën, expositieruimten', code: 'Musea, kunstgalerieën, expositieruimten' },
  { name: 'Natuursteenbewerking', code: 'Natuursteenbewerking' },
  { name: 'Onroerend goed bemiddeling en beheer', code: 'Onroerend goed bemiddeling en beheer' },
  { name: 'Ontwerpen, produceren en uitgeven van Software', code: 'Ontwerpen, produceren en uitgeven van Software' },
  { name: 'Ontwerpers (interieur, kleding e.d.)', code: 'Ontwerpers (interieur, kleding e.d.)' },
  { name: 'Opvangtehuizen t.b.v. kinderen/volwassenen', code: 'Opvangtehuizen t.b.v. kinderen/volwassenen' },
  { name: 'Organiseren van congressen en beurzen', code: 'Organiseren van congressen en beurzen' },
  { name: 'Overheid', code: 'Overheid' },
  { name: 'Overig onderwijs', code: 'Overig onderwijs' },
  { name: 'Overige activiteiten transport', code: 'Overige activiteiten transport' },
  { name: 'Overige belangenbehartiging organisatie', code: 'Overige belangenbehartiging organisatie' },
  { name: 'Overige dierenkwekerij', code: 'Overige dierenkwekerij' },
  { name: 'Overige gespecialiseerde reiniging', code: 'Overige gespecialiseerde reiniging' },
  { name: 'Overige gezondheidszorg activiteiten', code: 'Overige gezondheidszorg activiteiten' },
  { name: 'Overige telecommunicatie', code: 'Overige telecommunicatie' },
  { name: 'Particuliere beveiliging', code: 'Particuliere beveiliging' },
  { name: 'Pensioenfondsen', code: 'Pensioenfondsen' },
  { name: 'Persagentschappen', code: 'Persagentschappen' },
  { name: 'Plantenvermeerdering', code: 'Plantenvermeerdering' },
  { name: 'Politieke organisaties', code: 'Politieke organisaties' },
  { name: 'Postdiensten', code: 'Postdiensten' },
  { name: 'Pret- en themaparken, kermisactiviteiten', code: 'Pret- en themaparken, kermisactiviteiten' },
  { name: 'Primair en speciaal onderwijs', code: 'Primair en speciaal onderwijs' },
  { name: 'Productie kant- en klaarmaaltijden', code: 'Productie kant- en klaarmaaltijden' },
  { name: 'Productie overige voedingswaren', code: 'Productie overige voedingswaren' },
  { name: 'Productie zeep, was, poets, reinigingsmiddelen', code: 'Productie zeep, was, poets, reinigingsmiddelen' },
  { name: 'Productie toiletpapier, tissues etc', code: 'Productie toiletpapier, tissues etc' },
  { name: 'Productie verpakkingsmateriaal van papier', code: 'Productie verpakkingsmateriaal van papier' },
  { name: 'Productie cacao, chocolade en suikerwerk', code: 'Productie cacao, chocolade en suikerwerk' },
  { name: 'Productie films en TV programmas', code: 'Productie films en TV programmas' },
  { name: 'Productie fineer, plaatmateriaal uit hout', code: 'Productie fineer, plaatmateriaal uit hout' },
  { name: 'Productie frisdranken, gebotteld water', code: 'Productie frisdranken, gebotteld water' },
  { name: 'Productie houten deuren, ramen etc', code: 'Productie houten deuren, ramen etc' },
  { name: 'Productie noodles, meel, graanproducten', code: 'Productie noodles, meel, graanproducten' },
  { name: 'Productie plantaardige, dierlijke vetten', code: 'Productie plantaardige, dierlijke vetten' },
  { name: 'Productie sterk alcoholische dranken', code: 'Productie sterk alcoholische dranken' },
  { name: 'Productie van bier, mouterijen', code: 'Productie van bier, mouterijen' },
  { name: 'Productie van brood banketbakkerswerk', code: 'Productie van brood banketbakkerswerk' },
  { name: 'Productie van meel', code: 'Productie van meel' },
  { name: 'Productie van vee- en huisdierenvoer', code: 'Productie van vee- en huisdierenvoer' },
  { name: 'Productie van wijn, cider', code: 'Productie van wijn, cider' },
  { name: 'Productie van zuivelproducten', code: 'Productie van zuivelproducten' },
  { name: 'Productie, verf, vernis, drukinkt', code: 'Productie, verf, vernis, drukinkt' },
  { name: 'Radio-omroepen', code: 'Radio-omroepen' },
  { name: 'Rechtskundige dienstverlening', code: 'Rechtskundige dienstverlening' },
  { name: 'Reclamebureaus en handel in advertentie', code: 'Reclamebureaus en handel in advertentie' },
  { name: 'Reisagentschappen', code: 'Reisagentschappen' },
  { name: 'Religieuze organisatie', code: 'Religieuze organisatie' },
  { name: 'Reparatie Computers en randapparatuur', code: 'Reparatie Computers en randapparatuur' },
  { name: 'Reparatie consumentenelektronica', code: 'Reparatie consumentenelektronica' },
  { name: 'Reparatie en stoffering van meubels', code: 'Reparatie en stoffering van meubels' },
  { name: 'Reparatie huishoudelijke apparatuur', code: 'Reparatie huishoudelijke apparatuur' },
  { name: 'Reparatie overige consumentenartikelen', code: 'Reparatie overige consumentenartikelen' },
  { name: 'Reparatie schoenen en lederwaren', code: 'Reparatie schoenen en lederwaren' },
  { name: 'Reparatie van communicatieapparatuur', code: 'Reparatie van communicatieapparatuur' },
  { name: 'Reparatie elektrische apparatuur', code: 'Reparatie elektrische apparatuur' },
  { name: 'Reparatie elektronisch, optisch app', code: 'Reparatie elektronisch, optisch app' },
  { name: 'Reparatie producten metaal', code: 'Reparatie producten metaal' },
  { name: 'Reparatie van machines', code: 'Reparatie van machines' },
  { name: 'Retail sale boeken en kantoorbehoeften', code: 'Retail sale boeken en kantoorbehoeften' },
  { name: 'Retail sale drogisterijen', code: 'Retail sale drogisterijen' },
  { name: 'Retail sale kleding en modeartikelen', code: 'Retail sale kleding en modeartikelen' },
  { name: 'Retail sale overige speciaalzaken', code: 'Retail sale overige speciaalzaken' },
  { name: 'Retail sale speelgoedartikelen', code: 'Retail sale speelgoedartikelen' },
  { name: 'Retail sale sportartikelen', code: 'Retail sale sportartikelen' },
  { name: 'Retail sale tweedehandse goederen', code: 'Retail sale tweedehandse goederen' },
  { name: 'Retail sale via internet', code: 'Retail sale via internet' },
  { name: 'Retailhandel huishoudelijke apparatuur', code: 'Retailhandel huishoudelijke apparatuur' },
  { name: 'Rijsteelt', code: 'Rijsteelt' },
  { name: 'Risicoanalisten en schadetaxateurs', code: 'Risicoanalisten en schadetaxateurs' },
  { name: 'Rundveehouderij', code: 'Rundveehouderij' },
  { name: 'Schapen en geitenkwekerij', code: 'Schapen en geitenkwekerij' },
  { name: 'Slachterijen en vleesverwerking', code: 'Slachterijen en vleesverwerking' },
  { name: 'Smeden, persen, profielwalsen metaal', code: 'Smeden, persen, profielwalsen metaal' },
  { name: 'Software installatie', code: 'Software installatie' },
  { name: 'Sport en recreatie onderwijs', code: 'Sport en recreatie onderwijs' },
  { name: 'Sportaccommodaties', code: 'Sportaccommodaties' },
  { name: 'Sportclub activiteiten', code: 'Sportclub activiteiten' },
  { name: 'Technisch voortgezet onderwijs', code: 'Technisch voortgezet onderwijs' },
  { name: 'Teelt specerij, medicinale gewassen', code: 'Teelt specerij, medicinale gewassen' },
  { name: 'Teelt van overige boomvruchten', code: 'Teelt van overige boomvruchten' },
  { name: 'Teelt van palmnoten', code: 'Teelt van palmnoten' },
  { name: 'Telecommunicatie via satelliet', code: 'Telecommunicatie via satelliet' },
  { name: 'Televisieomroepen', code: 'Televisieomroepen' },
  { name: 'Thuiszorg', code: 'Thuiszorg' },
  { name: 'Tour operator', code: 'Tour operator' },
  { name: 'Transport binnenvaart personen', code: 'Transport binnenvaart personen' },
  { name: 'Transport openbaar vervoer binnen steden', code: 'Transport openbaar vervoer binnen steden' },
  { name: 'Transport overig personenvervoer', code: 'Transport overig personenvervoer' },
  { name: 'Transport vliegmaatschappijen personen', code: 'Transport vliegmaatschappijen personen' },
  { name: 'Transport vliegmaatschappijen vracht', code: 'Transport vliegmaatschappijen vracht' },
  { name: 'Trust, beleggings- instellingen', code: 'Trust, beleggings- instellingen' },
  { name: 'Uitgeverijen van kranten', code: 'Uitgeverijen van kranten' },
  { name: 'Uitgeverijen boeken, tijdschriften', code: 'Uitgeverijen boeken, tijdschriften' },
  { name: 'Uitgeverijen overig', code: 'Uitgeverijen overig' },
  { name: 'Uitzendbureaus', code: 'Uitzendbureaus' },
  { name: 'Uitvaartverzorging, mortuaria, begraafplaats', code: 'Uitvaartverzorging, mortuaria, begraafplaats' },
  { name: 'Varkenskwekerij', code: 'Varkenskwekerij' },
  { name: 'Verhuur & Lease machines, kantoorapparatuur', code: 'Verhuur & Lease machines, kantoorapparatuur' },
  { name: 'Verhuur en lease van voertuigen', code: 'Verhuur en lease van voertuigen' },
  { name: 'Verhuur overige consumenten artikelen', code: 'Verhuur overige consumenten artikelen' },
  { name: 'Verhuur van sport- en recreatieartikelen', code: 'Verhuur van sport- en recreatieartikelen' },
  { name: 'Vermogensbeheer entiteiten', code: 'Vermogensbeheer entiteiten' },
  { name: 'Vermogensbeheer natuurlijke personen', code: 'Vermogensbeheer natuurlijke personen' },
  { name: 'Verpleeghuizen algemeen', code: 'Verpleeghuizen algemeen' },
  { name: 'Vertalers en tolken', code: 'Vertalers en tolken' },
  { name: 'Vervaardiging metalen en constructiewerken', code: 'Vervaardiging metalen en constructiewerken' },
  { name: 'Vervaardiging schoenen', code: 'Vervaardiging schoenen' },
  { name: 'Vervaardiging van bijouterieën', code: 'Vervaardiging van bijouterieën' },
  { name: 'Vervaardiging van cement', code: 'Vervaardiging van cement' },
  { name: 'Vervaardiging van glas en glaswerk', code: 'Vervaardiging van glas en glaswerk' },
  { name: 'Vervaardiging van keramische producten', code: 'Vervaardiging van keramische producten' },
  { name: 'Vervaardiging van meubels', code: 'Vervaardiging van meubels' },
  { name: 'Vervaardiging van muziekinstrumenten', code: 'Vervaardiging van muziekinstrumenten' },
  { name: 'Vervaardiging van plastiek', code: 'Vervaardiging van plastiek' },
  { name: 'Vervaardiging van producten en beton', code: 'Vervaardiging van producten en beton' },
  { name: 'Vervaardiging van sieraden', code: 'Vervaardiging van sieraden' },
  { name: 'Verwerking van groente en fruit', code: 'Verwerking van groente en fruit' },
  { name: 'Verwerking van rijst', code: 'Verwerking van rijst' },
  { name: 'Verzekeringsmaatschappijen (leven)', code: 'Verzekeringsmaatschappijen (leven)' },
  { name: 'Verzekeringsmaatschappijen (overig)', code: 'Verzekeringsmaatschappijen (overig)' },
  { name: 'Veterinaire dienstverlening', code: 'Veterinaire dienstverlening' },
  { name: 'Visserij zee- en kunst', code: 'Visserij zee- en kunst' },
  { name: 'Visverwerking', code: 'Visverwerking' },
  { name: 'Voortgezet onderwijs', code: 'Voortgezet onderwijs' },
  { name: 'Wasserijen, dry cleaning', code: 'Wasserijen, dry cleaning' },
  { name: 'Web portals', code: 'Web portals' },
  { name: 'Wellness', code: 'Wellness' },
  { name: 'Werknemersorganisatie', code: 'Werknemersorganisatie' },
  { name: 'Winning edelmetalen en overige metalen', code: 'Winning edelmetalen en overige metalen' },
  { name: 'Winning van aardolie', code: 'Winning van aardolie' },
  { name: 'Winning zand, grind en klei', code: 'Winning zand, grind en klei' },
  { name: 'Ziekenhuizen', code: 'Ziekenhuizen' },
]

export const natureOfBusinessList = [
  { name: 'Administratieve Werkzaamheden', code: 'Administratieve Werkzaamheden' },
  { name: 'Advertentie Bureau', code: 'Advertentie Bureau' },
  { name: 'Adviesbureau', code: 'Adviesbureau' },
  { name: 'Advokatenkantoor', code: 'Advokatenkantoor' },
  { name: 'Afvaltransport', code: 'Afvaltransport' },
  { name: 'Agrarisch bedrijf', code: 'Agrarisch bedrijf' },
  { name: 'Ambassade', code: 'Ambassade' },
  { name: 'Apotheek', code: 'Apotheek' },
  { name: 'Appartementen', code: 'Appartementen' },
  { name: 'Architektenbureau', code: 'Architektenbureau' },
  { name: 'Artsenpraktijk', code: 'Artsenpraktijk' },
  { name: 'Associatiebedrijf', code: 'Associatiebedrijf' },
  { name: 'Assurantie Maatschappij', code: 'Assurantie Maatschappij' },
  { name: 'Audio Shop', code: 'Audio Shop' },
  { name: 'Auto Accesoires', code: 'Auto Accesoires' },
  { name: 'Auto Herstelwerkplaats', code: 'Auto Herstelwerkplaats' },
  { name: 'Auto verf en verfaccesoires', code: 'Auto verf en verfaccesoires' },
  { name: 'Autoairco bedrijf', code: 'Autoairco bedrijf' },
  { name: 'Autohandel', code: 'Autohandel' },
  { name: 'Automatiseringsbedrijf', code: 'Automatiseringsbedrijf' },
  { name: 'Autoverhuurbedrijf', code: 'Autoverhuurbedrijf' },
  { name: 'Bakkerij', code: 'Bakkerij' },
  { name: 'Banden Service', code: 'Banden Service' },
  { name: 'Bankinstelling', code: 'Bankinstelling' },
  { name: 'Bar & Cafe', code: 'Bar & Cafe' },
  { name: 'Barbershop', code: 'Barbershop' },
  { name: 'Bed & Breakfast', code: 'Bed & Breakfast' },
  { name: 'Begrafenis Onderneming', code: 'Begrafenis Onderneming' },
  { name: 'Beheer en Onderhoud', code: 'Beheer en Onderhoud' },
  { name: 'Beheer van haven', code: 'Beheer van haven' },
  { name: 'Beheer/Onderhoud van Primaire wegen', code: 'Beheer/Onderhoud van Primaire wegen' },
  { name: 'Bejaarden Tehuis', code: 'Bejaarden Tehuis' },
  { name: 'Beladingsbedrijf', code: 'Beladingsbedrijf' },
  { name: 'Bemiddelingsbedrijf', code: 'Bemiddelingsbedrijf' },
  { name: 'Bemonsteringsbedrijf', code: 'Bemonsteringsbedrijf' },
  { name: 'Beton Industrie', code: 'Beton Industrie' },
  { name: 'Beveiligingsbedrijf', code: 'Beveiligingsbedrijf' },
  { name: 'Bibliotheek', code: 'Bibliotheek' },
  { name: 'Blikzagerij', code: 'Blikzagerij' },
  { name: 'Bloemisterij', code: 'Bloemisterij' },
  { name: 'Boekhandel', code: 'Boekhandel' },
  { name: 'Boerderij', code: 'Boerderij' },
  { name: 'Bosexploitatie', code: 'Bosexploitatie' },
  { name: 'Bouw en Civieltechnische Werken', code: 'Bouw en Civieltechnische Werken' },
  { name: 'Bouw- en Constructiebedrijf', code: 'Bouw- en Constructiebedrijf' },
  { name: 'Bouw- en Lasconstructiebedrijf', code: 'Bouw- en Lasconstructiebedrijf' },
  { name: 'Bouwbedrijf', code: 'Bouwbedrijf' },
  { name: 'Bouwmaterialen', code: 'Bouwmaterialen' },
  { name: 'Brandstof leverancier', code: 'Brandstof leverancier' },
  { name: 'Brom- & Fiets Handel', code: 'Brom- & Fiets Handel' },
  { name: 'Bromfiets onderdelen verkoop', code: 'Bromfiets onderdelen verkoop' },
  { name: 'Cafetaria', code: 'Cafetaria' },
  { name: 'Callcenter', code: 'Callcenter' },
  { name: 'Cambio', code: 'Cambio' },
  { name: 'Carwash', code: 'Carwash' },
  { name: 'Casino', code: 'Casino' },
  { name: 'Catering', code: 'Catering' },
  { name: 'Celshop', code: 'Celshop' },
  { name: 'Chemicalienbedrijf', code: 'Chemicalienbedrijf' },
  { name: 'Club', code: 'Club' },
  { name: 'Coaching and Training Centre', code: 'Coaching and Training Centre' },
  { name: 'Communicatiebedrijf', code: 'Communicatiebedrijf' },
  { name: 'Computerbedrijf', code: 'Computerbedrijf' },
  { name: 'Confectiebedrijf', code: 'Confectiebedrijf' },
  { name: 'Constructiebedrijf', code: 'Constructiebedrijf' },
  { name: 'Consultancy', code: 'Consultancy' },
  { name: 'Contractors', code: 'Contractors' },
  { name: 'Coöperatie', code: 'Coöperatie' },
  { name: 'Copy Centre', code: 'Copy Centre' },
  { name: 'Creche', code: 'Creche' },
  { name: 'Cyber Cafe', code: 'Cyber Cafe' },
  { name: 'Dakplatenfabriek', code: 'Dakplatenfabriek' },
  { name: 'Design', code: 'Design' },
  { name: 'Deurwaarderskantoor', code: 'Deurwaarderskantoor' },
  { name: 'Dienstverlening', code: 'Dienstverlening' },
  { name: 'Dierenasiel', code: 'Dierenasiel' },
  { name: 'Dierenpoli', code: 'Dierenpoli' },
  { name: 'Discotheek', code: 'Discotheek' },
  { name: 'Distributie', code: 'Distributie' },
  { name: 'Douane Expeditie', code: 'Douane Expeditie' },
  { name: 'Drugstore', code: 'Drugstore' },
  { name: 'Drukkerij', code: 'Drukkerij' },
  { name: 'Duikersbedrijf', code: 'Duikersbedrijf' },
  { name: 'Ecotoerisme', code: 'Ecotoerisme' },
  { name: 'Educatie', code: 'Educatie' },
  { name: 'Electrotechnisch Bedrijf', code: 'Electrotechnisch Bedrijf' },
  { name: 'Embroidery', code: 'Embroidery' },
  { name: 'Energie Bedrijf', code: 'Energie Bedrijf' },
  { name: 'Event Planning', code: 'Event Planning' },
  { name: 'Exploitatie Bedrijf', code: 'Exploitatie Bedrijf' },
  { name: 'Exploratiebedrijf', code: 'Exploratiebedrijf' },
  { name: 'Fabriek & Magazijn', code: 'Fabriek & Magazijn' },
  { name: 'Feestzaal', code: 'Feestzaal' },
  { name: 'Financieel Bureau', code: 'Financieel Bureau' },
  { name: 'Foam Fabriek', code: 'Foam Fabriek' },
  { name: 'Fotostudio', code: 'Fotostudio' },
  { name: 'Glashandel', code: 'Glashandel' },
  { name: 'Goud- en Zilversmid', code: 'Goud- en Zilversmid' },
  { name: 'Goudopkoop', code: 'Goudopkoop' },
  { name: 'Graafwerkzaamheden', code: 'Graafwerkzaamheden' },
  { name: 'Grafisch Ontwerp Bureau', code: 'Grafisch Ontwerp Bureau' },
  { name: 'Grondverzet & Transportbedrijf', code: 'Grondverzet & Transportbedrijf' },
  { name: 'Groothandel', code: 'Groothandel' },
  { name: 'Hair & Beauty Salon', code: 'Hair & Beauty Salon' },
  { name: 'Handelsonderneming', code: 'Handelsonderneming' },
  { name: 'Holdingmaatschappij', code: 'Holdingmaatschappij' },
  { name: 'Horeca/Wafelfabriek', code: 'Horeca/Wafelfabriek' },
  { name: 'Hotel', code: 'Hotel' },
  { name: 'Hout Exportbedrijf', code: 'Hout Exportbedrijf' },
  { name: 'Houthandel', code: 'Houthandel' },
  { name: 'Houtmarkt', code: 'Houtmarkt' },
  { name: 'Houtverwerkingsbedrijf', code: 'Houtverwerkingsbedrijf' },
  { name: 'Huishouding', code: 'Huishouding' },
  { name: 'ICT Bedrijf', code: 'ICT Bedrijf' },
  { name: 'ICT Dienstverlening', code: 'ICT Dienstverlening' },
  { name: 'Ijsfabriek en Cafetaria', code: 'Ijsfabriek en Cafetaria' },
  { name: 'Import / Export Bedrijf', code: 'Import / Export Bedrijf' },
  { name: 'Incasso Bedrijf', code: 'Incasso Bedrijf' },
  { name: 'Industrie', code: 'Industrie' },
  { name: 'Ingenieursbureau', code: 'Ingenieursbureau' },
  { name: 'Inklaring- en Transportbedrijf', code: 'Inklaring- en Transportbedrijf' },
  { name: 'Insectenbestrijding', code: 'Insectenbestrijding' },
  { name: 'Inspectie', code: 'Inspectie' },
  { name: 'Installatiebedrijf', code: 'Installatiebedrijf' },
  { name: 'Interieur Bedrijf', code: 'Interieur Bedrijf' },
  { name: 'Internationale Organisatie', code: 'Internationale Organisatie' },
  { name: 'Investments', code: 'Investments' },
  { name: 'Juwelier', code: 'Juwelier' },
  { name: 'Kansspelen', code: 'Kansspelen' },
  { name: 'Kantine', code: 'Kantine' },
  { name: 'Kantoor', code: 'Kantoor' },
  { name: 'Kapsalon', code: 'Kapsalon' },
  { name: 'Kartonnenfabriek', code: 'Kartonnenfabriek' },
  { name: 'Keramische Werken', code: 'Keramische Werken' },
  { name: 'Kerkgemeente', code: 'Kerkgemeente' },
  { name: 'Keuringsstation', code: 'Keuringsstation' },
  { name: 'Keurmeester', code: 'Keurmeester' },
  { name: 'Kinderopvang', code: 'Kinderopvang' },
  { name: 'Klusjesman', code: 'Klusjesman' },
  { name: 'Koeltechnisch Bedrijf', code: 'Koeltechnisch Bedrijf' },
  { name: 'Konfectie', code: 'Konfectie' },
  { name: 'Laboratorium', code: 'Laboratorium' },
  { name: 'Landbouw,Veeteelt & Visserij', code: 'Landbouw,Veeteelt & Visserij' },
  { name: 'Landmeetkundig Bureau', code: 'Landmeetkundig Bureau' },
  { name: 'Las- en Constructiebedrijf', code: 'Las- en Constructiebedrijf' },
  { name: 'Logistiek', code: 'Logistiek' },
  { name: 'Logopediepraktijk', code: 'Logopediepraktijk' },
  { name: 'Loodgieterij', code: 'Loodgieterij' },
  { name: 'Loterij shop', code: 'Loterij shop' },
  { name: 'Luchtvaartmaatschappij', code: 'Luchtvaartmaatschappij' },
  { name: 'Luchtvracht', code: 'Luchtvracht' },
  { name: 'Machine en Instrumenten Fabriek', code: 'Machine en Instrumenten Fabriek' },
  { name: 'Magazijn', code: 'Magazijn' },
  { name: 'Management', code: 'Management' },
  { name: 'Marketing & Sales', code: 'Marketing & Sales' },
  { name: 'Markt', code: 'Markt' },
  { name: 'Massagesalon', code: 'Massagesalon' },
  { name: 'Mastklimmers', code: 'Mastklimmers' },
  { name: 'Materiaal Verhuurbedrijf', code: 'Materiaal Verhuurbedrijf' },
  { name: 'Mediabedrijf', code: 'Mediabedrijf' },
  { name: 'Medisch Technisch Dienst', code: 'Medisch Technisch Dienst' },
  { name: 'Metaalbewerking', code: 'Metaalbewerking' },
  { name: 'Meubel & Interieur accesoires', code: 'Meubel & Interieur accesoires' },
  { name: 'Mijnbouw', code: 'Mijnbouw' },
  { name: 'Ministerie', code: 'Ministerie' },
  { name: 'Modellen bureau', code: 'Modellen bureau' },
  { name: 'Motoren verkoop en Reparatiebedrijf', code: 'Motoren verkoop en Reparatiebedrijf' },
  { name: 'Museum', code: 'Museum' },
  { name: 'N.G.O. en Opvang voor HIV Positieven', code: 'N.G.O. en Opvang voor HIV Positieven' },
  { name: 'Nacht Club', code: 'Nacht Club' },
  { name: 'Natuurbehoud', code: 'Natuurbehoud' },
  { name: 'Nierdialyse Centrum', code: 'Nierdialyse Centrum' },
  { name: 'Notariaat', code: 'Notariaat' },
  { name: 'Nutsbedrijf', code: 'Nutsbedrijf' },
  { name: 'Olie Raffinaderij', code: 'Olie Raffinaderij' },
  { name: 'Onderhoudsbedrijf', code: 'Onderhoudsbedrijf' },
  { name: 'Onderwijsinstelling', code: 'Onderwijsinstelling' },
  { name: 'Onderzoeks Instituut', code: 'Onderzoeks Instituut' },
  { name: 'Onroerend Goed', code: 'Onroerend Goed' },
  { name: 'ontbossen', code: 'ontbossen' },
  { name: 'Opkoop en Export rondhout', code: 'Opkoop en Export rondhout' },
  { name: 'Opleidingsinstituut', code: 'Opleidingsinstituut' },
  { name: 'Oppashuis', code: 'Oppashuis' },
  { name: 'Opruimingsdienst', code: 'Opruimingsdienst' },
  { name: 'Opslag Magazijn', code: 'Opslag Magazijn' },
  { name: 'Opticien', code: 'Opticien' },
  { name: 'Opvang van Volwassen m/e beperking (drugs-alcohol', code: 'Opvang van Volwassen m/e beperking (drugs-alcohol' },
  { name: 'Opvangcentrum', code: 'Opvangcentrum' },
  { name: 'Organisatie', code: 'Organisatie' },
  { name: 'Pakkettendienst', code: 'Pakkettendienst' },
  { name: 'Papierhandel', code: 'Papierhandel' },
  { name: 'Parkeren', code: 'Parkeren' },
  { name: 'Parmaceutisch Groothandel', code: 'Parmaceutisch Groothandel' },
  { name: 'Pelmolen', code: 'Pelmolen' },
  { name: 'Pension', code: 'Pension' },
  { name: 'Plastic Fabriek', code: 'Plastic Fabriek' },
  { name: 'Pluimvee', code: 'Pluimvee' },
  { name: 'Posterij', code: 'Posterij' },
  { name: 'Produktiebedrijf', code: 'Produktiebedrijf' },
  { name: 'Project Ontwikkeling', code: 'Project Ontwikkeling' },
  { name: 'Radio & TV reparatie', code: 'Radio & TV reparatie' },
  { name: 'Radiodiagnotic/Echografie', code: 'Radiodiagnotic/Echografie' },
  { name: 'Radiostation', code: 'Radiostation' },
  { name: 'Reclame Bureau', code: 'Reclame Bureau' },
  { name: 'Recreatie Oord', code: 'Recreatie Oord' },
  { name: 'Recycling', code: 'Recycling' },
  { name: 'Reisbureau', code: 'Reisbureau' },
  { name: 'Religieuze Orga', code: 'Religieuze Orga' },
  { name: 'Reparatie Electrische artikelen', code: 'Reparatie Electrische artikelen' },
  { name: 'Reparatie Monteur & Lasbedrijf', code: 'Reparatie Monteur & Lasbedrijf' },
  { name: 'Reparatie van Schepen', code: 'Reparatie van Schepen' },
  { name: 'Rijschool', code: 'Rijschool' },
  { name: 'Rijstbedrijf', code: 'Rijstbedrijf' },
  { name: 'Scheepsagent', code: 'Scheepsagent' },
  { name: 'Scheepvaart Regulatiebedrijf', code: 'Scheepvaart Regulatiebedrijf' },
  { name: 'Scheepvaartmaatschappij', code: 'Scheepvaartmaatschappij' },
  { name: 'Schietschool', code: 'Schietschool' },
  { name: 'Schildersbedrijf', code: 'Schildersbedrijf' },
  { name: 'School', code: 'School' },
  { name: 'Schoonmaakbedrijf', code: 'Schoonmaakbedrijf' },
  { name: 'Schrootbedrijf', code: 'Schrootbedrijf' },
  { name: 'Slachterij', code: 'Slachterij' },
  { name: 'Slagerij', code: 'Slagerij' },
  { name: 'Sleepbedrijf', code: 'Sleepbedrijf' },
  { name: 'Slijterij', code: 'Slijterij' },
  { name: 'Sloopbedrijf', code: 'Sloopbedrijf' },
  { name: 'Snackbar', code: 'Snackbar' },
  { name: 'Sociale Instelling', code: 'Sociale Instelling' },
  { name: 'Sportcentrum', code: 'Sportcentrum' },
  { name: 'Sportschool', code: 'Sportschool' },
  { name: 'Sportzaak', code: 'Sportzaak' },
  { name: 'Spuit -en Uitdeuk', code: 'Spuit -en Uitdeuk' },
  { name: 'Steenslag', code: 'Steenslag' },
  { name: 'Stichting', code: 'Stichting' },
  { name: 'Straalbedrijf', code: 'Straalbedrijf' },
  { name: 'Stuwadoorsbedrijf', code: 'Stuwadoorsbedrijf' },
  { name: 'Supermarkt', code: 'Supermarkt' },
  { name: 'Tandartsen Praktijk', code: 'Tandartsen Praktijk' },
  { name: 'Tandtechnici Lab', code: 'Tandtechnici Lab' },
  { name: 'Taxatie Bedrijf', code: 'Taxatie Bedrijf' },
  { name: 'Taxibedrijf', code: 'Taxibedrijf' },
  { name: 'Technisch bedrijf', code: 'Technisch bedrijf' },
  { name: 'Tehuis', code: 'Tehuis' },
  { name: 'Telecommunicatie Bedrijf', code: 'Telecommunicatie Bedrijf' },
  { name: 'Technische dienst', code: 'Technische dienst' },
  { name: 'Textiel', code: 'Textiel' },
  { name: 'Thuiszorg', code: 'Thuiszorg' },
  { name: 'Toerisme', code: 'Toerisme' },
  { name: 'Toezichthouder', code: 'Toezichthouder' },
  { name: 'Toiletpapierbedrijf', code: 'Toiletpapierbedrijf' },
  { name: 'Tourbedrijf', code: 'Tourbedrijf' },
  { name: 'Transp/distributie bedrijf voor brandst en smeerm.', code: 'Transp/distributie bedrijf voor brandst en smeerm.' },
  { name: 'Transportbedrijf', code: 'Transportbedrijf' },
  { name: 'Triplexfabriek', code: 'Triplexfabriek' },
  { name: 'Tuinbouw', code: 'Tuinbouw' },
  { name: 'Uitgeverij', code: 'Uitgeverij' },
  { name: 'Uitvaartbedrijf', code: 'Uitvaartbedrijf' },
  { name: 'Uitzendbureau', code: 'Uitzendbureau' },
  { name: 'Vastgoed', code: 'Vastgoed' },
  { name: 'Veldwerk', code: 'Veldwerk' },
  { name: 'Verf groothandel/Retail', code: 'Verf groothandel/Retail' },
  { name: 'Verhuurbedrijf', code: 'Verhuurbedrijf' },
  { name: 'Verkavelings- en Bouwbedrijf', code: 'Verkavelings- en Bouwbedrijf' },
  { name: 'Verlichtingsarmaturenfabriek', code: 'Verlichtingsarmaturenfabriek' },
  { name: 'Vervoersbedrijf', code: 'Vervoersbedrijf' },
  { name: 'Verwerkingsbedrijf', code: 'Verwerkingsbedrijf' },
  { name: 'Visserij', code: 'Visserij' },
  { name: 'Visverwerkingsbedrijf', code: 'Visverwerkingsbedrijf' },
  { name: 'Voedingstechnologiebedrijf', code: 'Voedingstechnologiebedrijf' },
  { name: 'Voertuig Techniek', code: 'Voertuig Techniek' },
  { name: 'Vuilophaal-en Verwerkingsdienst', code: 'Vuilophaal-en Verwerkingsdienst' },
  { name: 'Waardetransport', code: 'Waardetransport' },
  { name: 'Wasserij', code: 'Wasserij' },
  { name: 'Wateroplossing', code: 'Wateroplossing' },
  { name: 'Watervoorziening', code: 'Watervoorziening' },
  { name: 'Winkel', code: 'Winkel' },
  { name: 'Zoo', code: 'Zoo' },
  { name: 'Zuivelfabriek', code: 'Zuivelfabriek' },
  { name: 'Zuurstoffabriek', code: 'Zuurstoffabriek' },
  { name: 'Zwaar materiaal', code: 'Zwaar materiaal' },
  { name: 'Zwembad', code: 'Zwembad' },
  { name: 'Zwemschool', code: 'Zwemschool' },
]

export const surinameCityList = [
  { name: 'Albina', code: 'Albina' },
  { name: 'Alkmaar', code: 'Alkmaar' },
  { name: 'Bakie', code: 'Bakie' },
  { name: 'Beekhuizen', code: 'Beekhuizen' },
  { name: 'Bigi Poika', code: 'Bigi Poika' },
  { name: 'Blauwgrond', code: 'Blauwgrond' },
  { name: 'Boven-Coppename', code: 'Boven-Coppename' },
  { name: 'Boven-Saramacca', code: 'Boven-Saramacca' },
  { name: 'Boven-Suriname', code: 'Boven-Suriname' },
  { name: 'Brownsweg', code: 'Brownsweg' },
  { name: 'Calcutta', code: 'Calcutta' },
  { name: 'Carolina', code: 'Carolina' },
  { name: 'Centrum', code: 'Centrum' },
  { name: 'Coeroeni', code: 'Coeroeni' },
  { name: 'De Nieuwe Grond', code: 'De Nieuwe Grond' },
  { name: 'Domburg', code: 'Domburg' },
  { name: 'Flora', code: 'Flora' },
  { name: 'Galibi', code: 'Galibi' },
  { name: 'Groningen', code: 'Groningen' },
  { name: 'Groot Henar', code: 'Groot Henar' },
  { name: 'Houttuin', code: 'Houttuin' },
  { name: 'Jarikaba', code: 'Jarikaba' },
  { name: 'Johanna Maria', code: 'Johanna Maria' },
  { name: 'Kabalebo', code: 'Kabalebo' },
  { name: 'Kampong Baroe', code: 'Kampong Baroe' },
  { name: 'Klaaskreek', code: 'Klaaskreek' },
  { name: 'Koewarasan', code: 'Koewarasan' },
  { name: 'Kwakoegron', code: 'Kwakoegron' },
  { name: 'Kwatta', code: 'Kwatta' },
  { name: 'Latour', code: 'Latour' },
  { name: 'Lelydorp', code: 'Lelydorp' },
  { name: 'Livorno', code: 'Livorno' },
  { name: 'Margaretha', code: 'Margaretha' },
  { name: 'Marshallkreek', code: 'Marshallkreek' },
  { name: 'Meerzorg', code: 'Meerzorg' },
  { name: 'Moengo', code: 'Moengo' },
  { name: 'Moengo Tapoe', code: 'Moengo Tapoe' },
  { name: 'Munder', code: 'Munder' },
  { name: 'Nieuw-Amsterdam', code: 'Nieuw-Amsterdam' },
  { name: 'Nieuw-Nickerie', code: 'Nieuw-Nickerie' },
  { name: 'Noord', code: 'Noord' },
  { name: 'Oost', code: 'Oost' },
  { name: 'Oostelijke Polders', code: 'Oostelijke Polders' },
  { name: 'Patamacca', code: 'Patamacca' },
  { name: 'Pontbuiten', code: 'Pontbuiten' },
  { name: 'Rainville', code: 'Rainville' },
  { name: 'Sarakreek', code: 'Sarakreek' },
  { name: 'Saramacca Polder', code: 'Saramacca Polder' },
  { name: 'Tamanredjo', code: 'Tamanredjo' },
  { name: 'Tammenga', code: 'Tammenga' },
  { name: 'Tapanahoni', code: 'Tapanahoni' },
  { name: 'Tijgerkreek', code: 'Tijgerkreek' },
  { name: 'Totness', code: 'Totness' },
  { name: 'Wageningen', code: 'Wageningen' },
  { name: 'Wanhatti', code: 'Wanhatti' },
  { name: 'Wayamboweg', code: 'Wayamboweg' },
  { name: 'Weg Naar Zee', code: 'Weg Naar Zee' },
  { name: 'Welgelegen', code: 'Welgelegen' },
  { name: 'Westelijke Polders', code: 'Westelijke Polders' },
  { name: 'Zuid', code: 'Zuid' },
]

export const currencyList = [
  { name: 'SRD', code: 'SRD' },
  { name: 'USD', code: 'USD' },
  { name: 'EURO', code: 'EURO' },
]

export const bankList = [
  { name: 'De Surinaamse Bank', code: '1' },
  { name: 'Surinaamse Volkscredietbank', code: '2' },
  { name: 'Hakrinbank NV', code: '3' },
  { name: 'Republic Bank', code: '4' },
  { name: 'Surichange Bank NV', code: '5' },
  { name: 'GODO', code: '6' },
  { name: 'Surinaamse Post Spaar Bank', code: '7' },
  { name: 'Trustbank Amanah', code: '8' },
  { name: 'Finabank', code: '9' },
]

export const nationalityList = [
  { name: 'Afghaans', code: 'Afghaans' },
  { name: 'Albanees', code: 'Albanees' },
  { name: 'Algerijn', code: 'Algerijn' },
  { name: 'Andorrese', code: 'Andorrese' },
  { name: 'Angolese', code: 'Angolese' },
  { name: 'Antiguan of Barbudan', code: 'Antiguan of Barbudan' },
  { name: 'Argentinië', code: 'Argentinië' },
  { name: 'Armeens', code: 'Armeens' },
  { name: 'Australisch', code: 'Australisch' },
  { name: 'Oostenrijks', code: 'Oostenrijks' },
  { name: 'Azeri', code: 'Azeri' },
  { name: 'Bahamaanse', code: 'Bahamaanse' },
  { name: 'Bahreinse', code: 'Bahreinse' },
  { name: 'Bengalees', code: 'Bengalees' },
  { name: 'Barbadaans', code: 'Barbadaans' },
  { name: 'Belarusian', code: 'Belarusian' },
  { name: 'Belgisch', code: 'Belgisch' },
  { name: 'Belizean', code: 'Belizean' },
  { name: 'Beninees', code: 'Beninees' },
  { name: 'Bhutanese', code: 'Bhutanese' },
  { name: 'Boliviaanse', code: 'Boliviaanse' },
  { name: 'Bosniër of Herzegoviër', code: 'Bosniër of Herzegoviër' },
  { name: 'Motswana, Botswanan', code: 'Motswana, Botswanan' },
  { name: 'Braziliaans', code: 'Braziliaans' },
  { name: 'Bruneian', code: 'Bruneian' },
  { name: 'Bulgarian', code: 'Bulgarian' },
  { name: 'Burkinabé', code: 'Burkinabé' },
  { name: 'Birmaans', code: 'Birmaans' },
  { name: 'Burundese', code: 'Burundese' },
  { name: 'Cabo Verdean', code: 'Cabo Verdean' },
  { name: 'Cambodjaans', code: 'Cambodjaans' },
  { name: 'Kameroense', code: 'Kameroense' },
  { name: 'Canadees', code: 'Canadees' },
  { name: 'Centraal-Afrikaan', code: 'Centraal-Afrikaan' },
  { name: 'Tsjadische', code: 'Tsjadische' },
  { name: 'Chileens', code: 'Chileens' },
  { name: 'Chinese', code: 'Chinese' },
  { name: 'Colombiaans', code: 'Colombiaans' },
  { name: 'Comorian', code: 'Comorian' },
  { name: 'Congolees', code: 'Congolees' },
  { name: 'Costa Ricaans', code: 'Costa Ricaans' },
  { name: 'Kroatisch', code: 'Kroatisch' },
  { name: 'Cubaans', code: 'Cubaans' },
  { name: 'Cypriotisch', code: 'Cypriotisch' },
  { name: 'Tsjechisch', code: 'Tsjechisch' },
  { name: 'Deens', code: 'Deens' },
  { name: 'Djiboutiaanse', code: 'Djiboutiaanse' },
  { name: 'dominicaans', code: 'dominicaans' },
  { name: 'Ecuadoriaans', code: 'Ecuadoriaans' },
  { name: 'Egyptische', code: 'Egyptische' },
  { name: 'Salvadoraanse', code: 'Salvadoraanse' },
  { name: 'Equatoguinean', code: 'Equatoguinean' },
  { name: 'Eritrese', code: 'Eritrese' },
  { name: 'Estlands', code: 'Estlands' },
  { name: 'Ethiopische', code: 'Ethiopische' },
  { name: 'fijian', code: 'fijian' },
  { name: 'Finnish', code: 'Finnish' },
  { name: 'French', code: 'French' },
  { name: 'Gabonese', code: 'Gabonese' },
  { name: 'Gambiaanse', code: 'Gambiaanse' },
  { name: 'Georgisch', code: 'Georgisch' },
  { name: 'German', code: 'German' },
  { name: 'Ghanees', code: 'Ghanees' },
  { name: 'Gibraltar', code: 'Gibraltar' },
  { name: 'Grieks', code: 'Grieks' },
  { name: 'Grenadian', code: 'Grenadian' },
  { name: 'Guatemalteeks', code: 'Guatemalteeks' },
  { name: 'Guinese', code: 'Guinese' },
  { name: 'Bissau-Guinese', code: 'Bissau-Guinese' },
  { name: 'Guyanese', code: 'Guyanese' },
  { name: 'Haïtiaanse', code: 'Haïtiaanse' },
  { name: 'Hondurees', code: 'Hondurees' },
  { name: 'Hongaars', code: 'Hongaars' },
  { name: 'IJslands', code: 'IJslands' },
  { name: 'Indiaas', code: 'Indiaas' },
  { name: 'Indonesian', code: 'Indonesian' },
  { name: 'Iraans', code: 'Iraans' },
  { name: 'Iraaks', code: 'Iraaks' },
  { name: 'Iers', code: 'Iers' },
  { name: 'Israëlisch', code: 'Israëlisch' },
  { name: 'Italian', code: 'Italian' },
  { name: 'Ivoriaanse', code: 'Ivoriaanse' },
  { name: 'Jamaican', code: 'Jamaican' },
  { name: 'Japanese', code: 'Japanese' },
  { name: 'Jordaanse', code: 'Jordaanse' },
  { name: 'Kazachstani', code: 'Kazachstani' },
  { name: 'Keniaan', code: 'Keniaan' },
  { name: 'I-Kiribati', code: 'I-Kiribati' },
  { name: 'Noord-Koreaanse', code: 'Noord-Koreaanse' },
  { name: 'Zuid-Koreaanse', code: 'Zuid-Koreaanse' },
  { name: 'Koeweitse', code: 'Koeweitse' },
  { name: 'Kirgizië', code: 'Kirgizië' },
  { name: 'Laotiaans', code: 'Laotiaans' },
  { name: 'Lettish', code: 'Letlands' },
  { name: 'Libanees', code: 'Libanees' },
  { name: 'Basotho', code: 'Basotho' },
  { name: 'Liberiaans', code: 'Liberiaans' },
  { name: 'Libisch', code: 'Libisch' },
  { name: 'Liechtenstein is', code: 'Liechtenstein is' },
  { name: 'Litouws', code: 'Litouws' },
  { name: 'Luxemburgs', code: 'Luxemburgs' },
  { name: 'Macedonisch', code: 'Macedonisch' },
  { name: 'Malagasi', code: 'Malagasi' },
  { name: 'Malawiaanse', code: 'Malawiaanse' },
  { name: 'Maleisisch', code: 'Maleisisch' },
  { name: 'Maldivische', code: 'Maldivische' },
  { name: 'Malinees', code: 'Malinees' },
  { name: 'Maltees', code: 'Maltees' },
  { name: 'Marshallese', code: 'Marshallese' },
  { name: 'Martinican', code: 'Martinican' },
  { name: 'Mauritaanse', code: 'Mauritaanse' },
  { name: 'Mauritiaanse', code: 'Mauritiaanse' },
  { name: 'Mexicaans', code: 'Mexicaans' },
  { name: 'Micronesische', code: 'Micronesische' },
  { name: 'Moldovan', code: 'Moldovan' },
  { name: 'Monégasque', code: 'Monégasque' },
  { name: 'Mongools', code: 'Mongools' },
  { name: 'Montenegrijnse', code: 'Montenegrijnse' },
  { name: 'Marokkaans', code: 'Marokkaans' },
  { name: 'Mozambikaanse', code: 'Mozambikaanse' },
  { name: 'Namibisch', code: 'Namibisch' },
  { name: 'Nauruan', code: 'Nauruan' },
  { name: 'Nepalees', code: 'Nepalees' },
  { name: 'Nederlands', code: 'Nederlands' },
  { name: 'Zelanian', code: 'Zelanian' },
  { name: 'Nicaraguaans', code: 'Nicaraguaans' },
  { name: 'Nigerese', code: 'Nigerese' },
  { name: 'Nigeriaanse', code: 'Nigeriaanse' },
  { name: 'Northern Marianan', code: 'Northern Marianan' },
  { name: 'Norwegian', code: 'Norwegian' },
  { name: 'Omani', code: 'Omani' },
  { name: 'Pakistaans', code: 'Pakistaans' },
  { name: 'Palauan', code: 'Palauan' },
  { name: 'Palestijns', code: 'Palestijns' },
  { name: 'Panamees', code: 'Panamees' },
  { name: 'Papuan', code: 'Papuan' },
  { name: 'Paraguayaans', code: 'Paraguayaans' },
  { name: 'Peruviaans', code: 'Peruviaans' },
  { name: 'Filippijns', code: 'Filippijns' },
  { name: 'Polijsten', code: 'polijsten' },
  { name: 'Portuguese', code: 'Portuguese' },
  { name: 'Puerto Ricaan', code: 'Puerto Ricaan' },
  { name: 'Qatari', code: 'Qatari' },
  { name: 'Roemeense', code: 'Roemeense' },
  { name: 'Russian', code: 'Russian' },
  { name: 'Rwandese', code: 'Rwandese' },
  { name: 'Kittitian', code: 'Kittitian' },
  { name: 'Saint Lucian', code: 'Saint Lucian' },
  { name: 'Vincentiaan', code: 'Vincentiaan' },
  { name: 'Samoan', code: 'Samoan' },
  { name: 'San Marino', code: 'San Marino' },
  { name: 'São Toméan', code: 'São Toméan' },
  { name: 'Saoedi-Arabië', code: 'Saoedi-Arabië' },
  { name: 'Senegalees', code: 'Senegalees' },
  { name: 'Servisch', code: 'Servisch' },
  { name: 'Seychellen', code: 'Seychellen' },
  { name: 'Sierra Leonean', code: 'Sierra Leonean' },
  { name: 'Singaporean', code: 'Singaporean' },
  { name: 'Slovak', code: 'Slovak' },
  { name: 'Sloveens', code: 'Sloveens' },
  { name: 'Solomon Island', code: 'Solomon Island' },
  { name: 'Somalisch', code: 'Somalisch' },
  { name: 'Zuid-Afrikaans', code: 'Zuid-Afrikaans' },
  { name: 'Zuid-Soedanees', code: 'Zuid-Soedanees' },
  { name: 'Spanish', code: 'Spanish' },
  { name: 'Sri Lankaans', code: 'Sri Lankaans' },
  { name: 'Soedanees', code: 'Soedanees' },
  { name: 'Surinaamse', code: 'Surinaamse' },
  { name: 'Swazi', code: 'Swazi' },
  { name: 'Swedish', code: 'Swedish' },
  { name: 'Zwitsers', code: 'Zwitsers' },
  { name: 'Syrisch', code: 'Syrisch' },
  { name: 'Tadzjiekse', code: 'Tadzjiekse' },
  { name: 'Tanzaniaans', code: 'Tanzaniaans' },
  { name: 'Thai', code: 'Thai' },
  { name: 'Timorese', code: 'Timorese' },
  { name: 'Togolese', code: 'Togolese' },
  { name: 'Tokelauan', code: 'Tokelauan' },
  { name: 'Tongaanse', code: 'Tongaanse' },
  { name: 'Trinidadian of Tobagonian', code: 'Trinidadian of Tobagonian' },
  { name: 'Tunesische', code: 'Tunesische' },
  { name: 'Turks', code: 'Turks' },
  { name: 'Turkmeense', code: 'Turkmeense' },
  { name: 'Tuvaluan', code: 'Tuvaluan' },
  { name: 'Oegandees', code: 'Oegandees' },
  { name: 'Oekraïens', code: 'Oekraïens' },
  { name: 'Emirati', code: 'Emirati' },
  { name: 'VK, Brits', code: 'VK, Brits' },
  { name: 'Verenigde Staten, VS, Amerikaans', code: 'Amerikaans' },
  { name: 'Uruguayaans', code: 'Uruguayaans' },
  { name: 'Oezbeeks', code: 'Oezbeeks' },
  { name: 'Vanuatuan', code: 'Vanuatuan' },
  { name: 'Vaticaan', code: 'Vaticaan' },
  { name: 'Venezolaans', code: 'Venezolaans' },
  { name: 'Vietnamees', code: 'Vietnamees' },
  { name: 'Jemenitisch', code: 'Jemenitisch' },
  { name: 'Zambiaanse', code: 'Zambiaanse' },
  { name: 'Zimbabwaanse', code: 'Zimbabwaanse' },
]
